import * as Yup from 'yup';

export const ApplyToJobPostWithResumeSchema = Yup.object().shape({
  resumeUrl: Yup.string().min(2),
  resumeFile: Yup.mixed()
    .nullable()
    // 1) check it’s a File and has an allowed extension
    .test('fileType', 'Only PDF, DOC or DOCX files are allowed', (value) => {
      if (!value) return true; // ok to be null/undefined
      if (!(value instanceof File)) return false;
      const name = value.name.toLowerCase();
      const ext = name.slice(name.lastIndexOf('.') + 1);
      return ['pdf', 'doc', 'docx'].includes(ext);
    })
    // 2) enforce max size 3 MB
    .test('fileSize', 'File size must not exceed 3MB', (value) => {
      if (!value) return true;
      return value instanceof File && value.size <= 3 * 1024 * 1024;
    }),
});

export type ApplyToJobPostWithResumeDataType = Yup.InferType<
  typeof ApplyToJobPostWithResumeSchema
>;

type InitialValues = {
  resumeUrl: string;
  resumeFile: string;
};

export const applyToJobPostWithResumeInitialValues: InitialValues = {
  resumeUrl: '',
  resumeFile: '',
};
